(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/hooks/use-get-game-url.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/hooks/use-get-game-url.js');

'use strict';

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const lbUtils = svs.components.lbUtils;
const dressWithPreliminaryRow = svs.components.marketplace.dressWithPreliminaryRow.dressWithPreliminaryRow;
const PARAM_MARKETPLACE_GAME_ID = svs.components.sport.tipsenShared.PARAM_MARKETPLACE_GAME_ID;
const _svs$utils$products = svs.utils.products,
  isTipsetProduct = _svs$utils$products.isTipsetProduct,
  productIds = _svs$utils$products.productIds;
const isPortedProduct = productId => {
  if (isTipsetProduct(productId) || [productIds.BOMBEN].includes(productId)) {
    return true;
  }
  return false;
};
const useGetGameUrl = game => {
  const activatedDrawId = game.activatedDrawId,
    drawNumber = game.drawNumber,
    productId = game.productId;
  const hasProductBeenPorted = isPortedProduct(productId);
  let searchString = lbUtils.getGameUrl({
    productId,
    drawNumber
  });
  if (hasProductBeenPorted) {
    searchString += "&".concat(PARAM_MARKETPLACE_GAME_ID, "=").concat(activatedDrawId);
  } else {
    searchString += "?".concat(PARAM_MARKETPLACE_GAME_ID, "=").concat(activatedDrawId, "&fromPlayTogether=true");
  }
  const gameUrl = useSelector(state => {
    if (activatedDrawId && drawNumber && productId) {
      return dressWithPreliminaryRow(state, activatedDrawId, productId, drawNumber, searchString);
    }
    return undefined;
  });
  return gameUrl;
};
setGlobal('svs.components.marketplace.gameList.hooks.useGetGameUrl', useGetGameUrl);

 })(window);